import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';
import {map} from 'rxjs/operators';
import {ApiMessageService} from '../../core/api-message.service';
import {Contesto} from './contesto.model';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_CONFIGURAZIONE} from '../../app-routing.module';

@Injectable()
export class ContestoService extends CommonService<Contesto> {

  public static ROUTE = 'contesto';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): Contesto {
    return JsonBaseBuilder.jsonToContesto(json);
  }

  public getModule(): string {
    return MODULE_CONFIGURAZIONE;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return ContestoService.ROUTE;
  }

  public existingDescr(descr: string, entity: Contesto): Observable<boolean> {
    return this.getBoolean('/existingdescr', new HttpParams()
      .set('descr', descr)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

  public existingSigla(sigla: string, entity: Contesto): Observable<boolean> {
    return this.getBoolean('/existingsigla', new HttpParams()
      .set('sigla', sigla)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

  public getTable(items: Contesto[]): Table {
    return Table.buildBaseTable(Contesto.getTableKeys(), items);
  }

  public getContestoIstituzionale(): Observable<Contesto> {
    return this.getAny('/istituzionale', new HttpParams()).pipe(map((item) => {
      const instance: Contesto = this._buildInstance(item);
      return instance;
    }));
  }

  public getAllContesti(): Observable<Contesto[]> {
    return this.getArray('/all', new HttpParams());
  }

  public getContesti(fromGerarchia: boolean): Observable<Contesto[]> {
    if (fromGerarchia)
      return this.getArray('/all/gerarchia', new HttpParams());
    return this.getAll();
  }
}
